// eslint-disable-next-line react/prop-types

import { GmapAddress } from "../../components";
import { AsyncSelectAntd } from "../index";

import React, { useEffect, useState } from "react";
import * as cmFun from "common/ulti/commonFunction";
import * as CONSTANTS from "../../../common/ulti/constants";
import { __DEV__ } from "../../../common/ulti/constants";
import { Input, Checkbox, Select, Switch, Radio, DatePicker, AutoComplete } from "antd";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import customParseFormat from "dayjs/plugin/customParseFormat";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

function FormInput({
  parentClass,
  labelClass,
  inputClass,
  required,
  readOnly,
  handleCheck,
  // select
  loadOptions,
  // radio
  options,
  // default
  type,
  label,
  onChange,
  errorLabel,
  pattern,
  ...props
}) {
  let { value } = props;

  const [_requiredErr, setRequiredErr] = useState(
    required ? { state: true, msg: "" } : { state: false, msg: "" }
  );
  const [_valid, setValid] = useState(true);

  const ERR_REQUIRED = "Vui lòng điền đầy đủ thông tin";
  // Báo lỗi kèm tên trường ("sai ở đâu"), fallback khi label không phải chuỗi
  const requiredMsg =
    typeof label === "string" && label ? `Vui lòng nhập ${label}` : ERR_REQUIRED;

  useEffect(() => {
    _checkRequired();
    if (pattern && value) {
      setValid(cmFun.validateInput(value, pattern));
    } else {
      setValid(true);
    }
  }, [value, required, pattern]);

  const _checkRequired = () => {
    if (required) {
      if (!value) {
        if (!_requiredErr.state) {
          setRequiredErr({ state: true, msg: "" });
        }
      } else {
        if (_requiredErr.state || _requiredErr.msg) {
          setRequiredErr({ state: false, msg: "" });
        }
      }
    } else {
      if (_requiredErr.state || _requiredErr.msg) {
        setRequiredErr({ state: false, msg: "" });
      }
    }
  };

  const handleOnBlur = async () => {
    if (!handleCheck) return;
    let checked = await handleCheck();
    if (checked) {
      setRequiredErr({ state: true, msg: "Dữ liệu trùng" });
    } else {
      setRequiredErr({ state: false, msg: "" });
      _checkRequired();
    }
  };

  const handleChgElmt = (evt, option) => {
    let val = null;
    let data = null;

    switch (type) {
      case "select":
        val = evt;
        data = option;
        break;
      case "asyncselect":
        val = evt;
        data = option;
        break;
      case "combobox":
        val = evt;
        data = { target: { id: props.id, value: evt } };
        break;
      case "checkbox":
        val = evt.target.checked;
        data = evt;
        break;
      case "switch":
        val = evt;
        data = { target: { id: props.id, checked: evt } };
        break;
      case "radio":
        val = evt.target.value;
        evt.target.id = props.id;
        data = evt;
        break;
      case "date":
        val = option;
        data = { target: { id: props.id, value: option } };
        break;
      default:
        val = evt.target.value;
        data = evt;
    }

    if (required && !val) {
      setRequiredErr({ state: true, msg: requiredMsg });
    } else {
      let nextValid = true;
      if (pattern && val) {
        nextValid = cmFun.validateInput(val, pattern);
      }
      if (type === "number" && val !== null && val !== undefined && val !== "") {
        const num = Number(val);
        if (Number.isNaN(num)) {
          nextValid = false;
        } else {
          if (props.min !== undefined && num < Number(props.min)) nextValid = false;
          if (props.max !== undefined && num > Number(props.max)) nextValid = false;
        }
      }
      setValid(nextValid);
      setRequiredErr({ state: false, msg: "" });
    }

    onChange(data);
  };

  const _renderTextarea = (_inputClass) => {
    return (
      <Input.TextArea
        {...props}
        className={_inputClass}
        onChange={handleChgElmt}
      />
    );
  };

  const _renderCheckbox = (_inputClass) => {
    return <Checkbox {...props} checked={value} onChange={handleChgElmt} />;
  };

  const _renderSwitch = () => {
    return <Switch {...props} checked={value} onChange={handleChgElmt} />;
  };

  const _renderRadio = () => {
    if (options.length === 1) {
      return <Radio>{options[0].label}</Radio>;
    } else {
      return (
        <Radio.Group {...props} onChange={handleChgElmt}>
          {options.map((item, index) => {
            return (
              <Radio key={index} value={item.value}>
                {item.label}
              </Radio>
            );
          })}
        </Radio.Group>
      );
    }
  };

  const _renderDatePicker = () => {
    return (
      <DatePicker
        {...props}
        value={
          props.value
            ? dayjs.isDayjs(props.value)
              ? props.value
              : dayjs(props.value, props.dateFormat || "DD/MM/YYYY")
            : null
        }
        defaultValue={
          props.value
            ? dayjs.isDayjs(props.value)
              ? props.value
              : dayjs(props.value, props.dateFormat || "DD/MM/YYYY")
            : null
        }
        format={props.dateFormat || "DD/MM/YYYY"} // Ensure display format is explicitly set
        onChange={handleChgElmt}
      />
    );
  };

  const _renderInput = (_inputClass) => {
    return (
      <Input
        {...props}
        className={_inputClass}
        onChange={handleChgElmt}
        onBlur={handleOnBlur}
        type={type || "text"}
      />
    );
  };

  const _renderGmapAddress = () => {
    return <GmapAddress {...props} onChange={handleChgElmt} />;
  };

  const _renderSelect = (_inputClass) => {
    return (
      <div className={_inputClass + " p-0"}>
        <Select
          {...props}
          options={options}
          defaultValue={value}
          showSearch={props.showSearch !== undefined ? props.showSearch : true}
          allowClear={props.allowClear !== undefined ? props.allowClear : true}
          optionFilterProp={props.optionFilterProp || "label"}
          filterOption={
            props.filterOption ||
            ((input, option) => {
              const lbl = (option?.label || "").toString().toLowerCase();
              return lbl.includes((input || "").toString().toLowerCase());
            })
          }
          onChange={handleChgElmt}
          style={{ width: "100%" }}
        />
      </div>
    );
  };

  const _renderAsyncSelect = (_inputClass) => {
    return (
      <div className={_inputClass + " p-0"}>
        <AsyncSelectAntd
          {...props}
          fetchOptions={loadOptions}
          onChange={handleChgElmt}
        />
      </div>
    );
  };

  const _renderCombobox = (_inputClass) => {
    return (
      <div className={_inputClass + " p-0"}>
        <AutoComplete
          {...props}
          options={options}
          value={value}
          onChange={handleChgElmt}
          filterOption={(inputValue, option) =>
            (option?.label ?? "")
              .toLowerCase()
              .includes((inputValue || "").toLowerCase())
          }
          style={{ width: "100%" }}
          allowClear={props.allowClear !== undefined ? props.allowClear : true}
        />
      </div>
    );
  };

  const renderChild = (_inputClass) => {
    switch (type) {
      case "textarea": // ok
        return _renderTextarea(_inputClass);

      case "gmapaddress":
        return _renderGmapAddress();

      case "select": // ok
        return _renderSelect(_inputClass);

      case "combobox": // ok
        return _renderCombobox(_inputClass);

      case "asyncselect": // ok
        return _renderAsyncSelect(_inputClass);

      case "checkbox": // ok
        return _renderCheckbox(_inputClass);

      case "switch": // ok
        return _renderSwitch();

      case "radio": // ok
        return _renderRadio();

      case "date": // ok
        return _renderDatePicker();

      default: // ok
        return _renderInput(_inputClass);
    }
  };

  let _parentClass = `${parentClass || "col-md-12"
    } form-row form-wrap form-group`;

  let _wrapperClass = "col-md-12 form-row form-no-spacing";

  let _labelClass = `${labelClass || (type == "checkbox" ? "label-input" : "col-md-12")
    }`;

  let _inputClass = `${inputClass || (type == "checkbox" ? "" : "col-md-12")} ${type == "select" ? " pl-0 pr-0" : ""
    }`;

  return (
    <div className={_parentClass}>
      <div className={_wrapperClass}>
        <label className={_labelClass}>
          {label}
          {required ? <span className="required">*</span> : null}
        </label>
        {renderChild(_inputClass)}
      </div>
      {!_valid || _requiredErr.msg || (_requiredErr.state && !value) ? (
        <span className={_labelClass}></span>
      ) : null}
      {!_valid || _requiredErr.msg ? (
        <label
          className={`${_inputClass} form-label-err`}
          name={CONSTANTS.LABEL_VALID_ERROR_NAME}
        >
          {_requiredErr.msg ? _requiredErr.msg : errorLabel}
        </label>
      ) : _requiredErr.state && !value ? (
        <label
          className={`${_inputClass} form-label-err`}
          name={CONSTANTS.LABEL_VALID_ERROR_NAME}
        >
          {requiredMsg}
        </label>
      ) : null}
    </div>
  );
}

FormInput.propTypes = {
  parentClass: PropTypes.string,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  handleCheck: PropTypes.func,
  loadOptions: PropTypes.func,
  options: PropTypes.array,
  type: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func,
  errorLabel: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.any,
  pattern: PropTypes.string,
  dateFormat: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FormInput;
